import { isNavbarItemAllowed } from 'features/navbar/isNavbarItemAllowed'
import { NAV_ITEMS_CONFIG, NavItemConfig } from 'features/navbar/navConfig'
import { SelectedTab } from 'features/navbar/types'
import type { RolodexPermissionsValues } from 'types'

import { isSidebarNavItemPermitted } from './isSidebarNavItemPermitted'

function isNavItemEntry(
  entry: [string, NavItemConfig]
): entry is [SelectedTab, NavItemConfig] {
  return Object.prototype.hasOwnProperty.call(NAV_ITEMS_CONFIG, entry[0])
}

export function getVisibleSidebarNavItems({
  canVisitSiteView,
  chatLayout,
  hasPermissions,
  navItemKeys,
  siteID,
}: {
  canVisitSiteView: boolean
  chatLayout: boolean
  hasPermissions: (permissions: RolodexPermissionsValues[]) => boolean
  navItemKeys: SelectedTab[] | undefined
  siteID: string | undefined
}): Array<[SelectedTab, NavItemConfig]> {
  return Object.entries(NAV_ITEMS_CONFIG)
    .filter(isNavItemEntry)
    .filter(([tabKey, config]) =>
      isNavbarItemAllowed(tabKey, navItemKeys, {
        requiresExplicitEnablement: config.requiresExplicitEnablement,
        enabledBy: config.enabledBy,
      })
    )
    .filter(([, config]) =>
      isSidebarNavItemPermitted({
        chatLayout,
        hasPermissions,
        gate: { requires: config.permissions, except: config.except },
      })
    )
    .filter(([, config]) => {
      if (config.shouldShow) {
        return config.shouldShow({ siteID: siteID ?? '', canVisitSiteView })
      }
      return true
    })
}
